export const environment = {
  production: false,
  url: 'https://digitallab.lipatinantioquia.com.co',
  urlPagos:'https://pasarelapagoslab.lipatinantioquia.com.co',
  // Canal de ayuda del header de escritorio (SPEC-003): WhatsApp de la Escuela.
  whatsappAyuda: '573245919450',
  // El Reglamento vigente publicado por la Liga (SPEC-004). Va aqui y no en la
  // plantilla: cuando la Liga publique la version del ciclo siguiente se cambia
  // en un sitio, y SPEC-009 lo repite en la pantalla de revisar.
  urlReglamento:
    'https://lipatinpdn.cdn.prismic.io/lipatinpdn/Z6YxC5bqstJ9-X5M_ReglamentoEscuelaLipatin2025.pdf',
  apiSolicitud: 'https://apim-lipatin-lab-001.azure-api.net/applications',
  apiDocument: 'https://apim-lipatin-lab-001.azure-api.net/docs',
  apiRegistration:'https://apim-lipatin-lab-001.azure-api.net/registration',
  apiPagos:'https://apim-lipatin-lab-001.azure-api.net/payments/v2',
  apiAdministration:'https://apim-lipatin-lab-001.azure-api.net/administrator',
  apiGestion:'https://apim-lipatin-lab-001.azure-api.net/membership',
  retrayPaymentStatusLimit:5,  paymentProductId:'cd587e19-e2c6-4af1-8875-f70738812957',
  paymentProductRenewalId:'a4572036-fc37-4adc-ac36-703e64200e5d',
  paymentTest:1,
  renewalModuleIsActive:true,
  sponsorshipModuleIsActive:false,
  diasHabilitadosMatriculaPostInicioCiclo:3,
  recaptcha: {
    siteKey: '6LctCZkpAAAAALLVgwZ-Gg2nDHEmW-bp69if9tsP',
  },
  apiManagementConfig:{
    academyApi: '06a7e8478e204c849f45d1ad754c7063',
    pagosApi:'e03dc452df104fe5a122ab62ff0e7400'
},
  blacklistMembers: [
    {
      idType: 'CC',
      idNumber: '1017203654'
    },
    {
      idType: 'TI',
      idNumber: '0987654321'
    }
  ],
};
